var create_account_popup = require( '../frontend/create-account-popup' );

var course_videos = ( function( $ ) {

	var $site_wrapper;
	var $player_container;

	var $course_controls;
	var $lesson_controls;
	var $lesson_tab_cards;
	var $next;
	var $prev;

	var player;
	var lesson;
	var played = false;

	var yt_player;
	var has_yt_overview = false;

	var restricted = false;

	var _init = function() {
		$site_wrapper = $( '#site-wrapper' );
        $player_container = $( '#course-video' );

		if ( $player_container.length <= 0 ) {
			return;
		}

		if ( $player_container.hasClass( 'restrict-video-changing' ) ) {
			restricted = true;
			create_account_popup.setup_popup_actions();
			create_account_popup.setup_triggers();
		}

		$course_controls  = $( '#single-course-controls' );
		$lesson_controls  = $( '#course-single-lessons' );
		$lesson_tab_cards = $( '#lessons' ).find( '.lesson' );
		$next = $lesson_controls.find( '.next' );
		$prev = $lesson_controls.find( '.prev' );

		// Vimeo isn't first video
        if ( $player_container.find( '.youtube-video' ).length === 1 ) {
			has_yt_overview = true;

			_load_youtube_api_script();

			_initial_reveal();

			window.onYouTubePlayerAPIReady = function() {
				_setup_youtube_overview();
			};

			if ( $player_container.find( '.vimeo-player-wrapper' ) ) {
				_setup_vimeo();
			}

        } else  {
        	_setup_vimeo();
		}

		// Handle video changes
		$( window ).on( 'hashchange', _hashchange );
	};

	var _initial_reveal = function() {
		// Setup the current lesson
		var slug = window.location.hash.substr(1 );

		if ( slug === 'overview' || slug === '' ) {
			_show_youtube_video();
		} else {
			_show_vimeo_video();
		}
	};

	var _setup_vimeo = function() {
		// Create a Vimeo player object
		player = new Vimeo.Player( $player_container.find( '.vimeo-video iframe' ) );

		// Autoplay
		player.on( 'ended', _video_ended );
		player.on( 'play', _play );

		// Setup the current lesson
		var slug = window.location.hash.substr(1 );

		set_lesson( slug );
	};

	var _setup_youtube_overview = function() {
		var vid_id = make_id( 8 );
		$player_container.find( 'iframe.youtube-player' ).attr( 'id', vid_id );

		yt_player = new YT.Player( vid_id, {
			events: { 'onStateChange': _yt_player_state_change }
		} );
	};

	var _yt_player_state_change = function( event ) {
		// Show first lesson on when overview has ended
		if ( event.data === YT.PlayerState.ENDED  ) {
			played = true;
			window.location.hash = $player_container.find( '.vimeo-player-wrapper' ).data( 'lesson-one-slug' );
			setTimeout( _show_vimeo_video, 100 );
		}
	};

	var _show_youtube_video = function() {
		var $youtube = $player_container.find( '.youtube-video' );

		// Already shown
		if ( $youtube.css( 'display' ) !== 'none' ) {
			return
		}

		$player_container.find( '.vimeo-player-wrapper' ).css( 'display', 'none' ).addClass( 'hid' ).removeClass( 'show' );
		$player_container.find( '.youtube-video' ).css( 'display', 'block' ).addClass( 'show' ).removeClass( 'hid' );
	};

	var _show_vimeo_video = function() {
		var $vimeo = $player_container.find( '.vimeo-player-wrapper' );

		// Already shown
		if ( $vimeo.css( 'display' ) !== 'none' ) {
			return
		}

		$player_container.find( '.youtube-video' ).css( 'display', 'none' ).addClass( 'hid' ).removeClass( 'show' );
		$player_container.find( '.vimeo-player-wrapper' ).css( 'display', 'block' ).addClass( 'show' ).removeClass( 'hid' );
	};

	var _play = function( data ) {
		played = true;

		// Only start listening for loaded events after the first play action
		player.on( 'loaded', _video_loaded );
	};

	var _video_ended = function( data ) {
		if ( autoplay_enabled() ) {
			var next_slug = get_lesson_slug( lesson.index + 1 );

			if ( next_slug ) {
				window.location.hash = next_slug;
			}
		}
	};

	var _video_loaded = function( data ) {
		if ( autoplay_enabled() ) {
			player.play();
		}
	};

	var autoplay_enabled = function() {
		return true;
	};

	var set_lesson = function( slug ) {
		lesson = get_lesson_details( slug );

		if ( lesson === null ) {
			return;
		}

		player.getVideoId().then( function( currentVideo ) {
			// Only load video if it's not already the current one, to avoid errors on iOS
			if ( currentVideo != lesson.hash ) {
				player.loadVideo( lesson.hash );

				// This is a hacky workaround because the loaded event no longer fires for loads - bug in Vimeo?
				// If bug is fixed this code can be removed
				if ( played ) {
					setTimeout( function() {
						player.play();
					}, 1000 );
				}
			}
		});

		// Update Now Playing
		var $lesson_cards = $lesson_controls.find( '.lesson-card' );
       	$lesson_cards.removeClass( 'playing' );
       	$lesson_cards.filter( function() {
			return ( $( this ).data( 'slug' ) === slug );
		} ).addClass( 'playing' );

		$lesson_tab_cards.removeClass( 'playing' );
		$lesson_tab_cards.filter( function() {
			return ( $( this ).data( 'slug' ) === slug );
		} ).addClass( 'playing' );

		// Change video title
		$course_controls.find( '.lesson-title' ).text( lesson.title );

		scroll_to_player();
	};

	var get_lesson_details = function( slug ) {
		if ( ! ( slug in ScriptData.videos ) ) {
			if ( restricted && slug ) {
				create_account_popup.open_popup();
				return null;
			} else {
				slug = ScriptData.video_slugs[0];
			}
		}

		return ScriptData.videos[ slug ];
	};

	var get_lesson_slug = function( index ) {
		if ( index < 0 || index >= ScriptData.videos.length ) {
			return false;
		}

		return ScriptData.video_slugs[ index ];
	};

	var _hashchange = function( event ) {
		var newSlug = location.hash.substr(1);

		var lesson = get_lesson_details( newSlug );

		if ( has_yt_overview && lesson !== null ) {
			if ( newSlug === 'overview' ) {
				_show_youtube_video();
			} else {
				_show_vimeo_video();
				yt_player.seekTo(0);
				yt_player.stopVideo();
			}
		}

		set_lesson( newSlug );
	};

	var scroll_to_player = function() {
        if ( ! player_on_screen() ) {
            var offset = $player_container.offset().top;
            offset -= $( '#wpadminbar' ).height();
            offset += $site_wrapper.scrollTop();
            offset -= 20;

			$( 'html, body' ).animate({
                scrollTop: offset
            }, 1000);
        }
	};

    var player_on_screen = function() {
    	var docViewTop = $( window ).scrollTop();
    	var docViewBottom = docViewTop + $( window ).height();

    	var elemTop = $player_container.offset().top;
    	var elemBottom = elemTop + $player_container.height();

    	return ( ( elemTop <= docViewBottom ) && ( elemBottom >= docViewTop ) );
    };

	var _load_youtube_api_script = function() {
		var tag = document.createElement( 'script' ),
			first_script_tag = document.getElementsByTagName( 'script' )[0];

		tag.id = 'youtube-iframe-api';
		tag.src = 'https://www.youtube.com/iframe_api';

		first_script_tag.parentNode.insertBefore( tag, first_script_tag );
	};

	var make_id = function( length ) {
		var text = '';
		var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

		for ( var i = 0; i < length; i++ ) {
			text += possible.charAt( Math.floor( Math.random() * possible.length ) );
		}

		return text;
	};

	if ( $( 'body.single-tutorial' ).length > 0 ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = course_videos;